import React from 'react';
import PropTypes from 'prop-types';
import { ArrowUpBlueIconPng, ArrowDownBlueIconPng } from 'images';
import { HoverStateProvider, ModalWrapper } from 'components';
import { withTranslation } from 'react-i18next';

class InputSelectDropdown extends React.PureComponent {
	static propTypes = {
		className: PropTypes.string,
		options: PropTypes.arrayOf(PropTypes.string),
		value: PropTypes.string,
		showError: PropTypes.bool,
		onChange: PropTypes.func,
		t: PropTypes.func
	}

	state = {
		expanded: false
	}

	handleToggle = () => {
		const { expanded } = this.state;
		this.setState({
			expanded: !expanded
		});
	}

	handleClick = item => {
		const { onChange } = this.props;
		this.setState({ expanded: false });
		onChange(item);
	}

	handleClickOutside = () => {
		setTimeout(() => this.setState({ expanded: false }), 100);
	}

	renderInput = isOpen => {
		const { t, value, showError } = this.props;
		return (
			<div
				className={`${
					isOpen
						? 'border-t border-l border-r rounded-t'
						: 'border rounded'
				} ${
					showError ? 'border-vermillion' : 'border-cerulean'
				} border-solid h-8 bg-white text-black shadow-md`}>
				<button
					type="button"
					className="px-2 w-full h-full flex items-center justify-between focus:outline-none"
					onClick={this.handleToggle}>
					<div className="mr-2 truncate">{t(value)}</div>
					<img
						src={
							isOpen
								? ArrowUpBlueIconPng
								: ArrowDownBlueIconPng
						}
						className="w-3"
						alt="arrow button" />
				</button>
			</div>
		);
	}

	renderOption = ({ hovered, item }) => {
		const { t, value } = this.props;
		const selected = value === item;
		return (
			<button
				type="button"
				className={`px-2 py-1 w-full text-left ${
					selected
						? 'bg-lightNavy text-white'
						: hovered
							? 'bg-gray-250'
							: 'bg-white'
				}`}
				onClick={() => {
					this.handleClick(item);
				}}>
				{t(item)}
			</button>
		);
	}

	renderOptions = () => {
		const { options } = this.props;
		const { expanded } = this.state;
		const filterItems = options
			// .filter(item => item !== value)
			.map(item => (
				<HoverStateProvider
					key={item}
					item={item}
					render={this.renderOption} />
			));
		if (expanded) {
			return (
				<ModalWrapper onClickOutside={this.handleClickOutside}>
					<div
						className="overflow-y-auto scrollbar-black absolute max-h-64 w-full pt-2 z-10 bg-white rounded-b border-l border-b border-r border-cerulean border-solid whitespace-pre">
						{filterItems}
					</div>
				</ModalWrapper>
			);
		} else {
			return null;
		}
	}

	render() {
		const { className } = this.props;
		const { expanded } = this.state;
		return (
			<div className={`relative ${className}`}>
				{this.renderInput(expanded)}
				{this.renderOptions()}
			</div>
		);
	}
}

export default withTranslation()(InputSelectDropdown);
